import { GregorioType } from '../enums/GregorioType';
import { GregorioNoteElement } from './GregorioNoteElement';
import { GregorioElement } from './GregorioSyllable';
import { NabcSnippet } from './NabcSnippet';

export class GregorioSegment {
  gabcNotations!: GregorioNoteElement[];
  nabcNotations!: NabcSnippet[];
  elements: GregorioElement[] = [];

  get realElements() {
    return this.elements.filter((e) => e.type === GregorioType.ELEMENT);
  }

  constructor(
    gabcNotations?: GregorioNoteElement[],
    nabcNotations?: NabcSnippet[],
  ) {
    this.gabcNotations = gabcNotations ?? [];
    this.nabcNotations = nabcNotations ?? [];
  }

  get hasBar(): boolean {
    return this.elements.some((e) => e.type === GregorioType.BAR);
  }

  get isBar(): boolean {
    return this.elements.every((e) => e.type === GregorioType.BAR);
  }

  get isClef(): boolean {
    return this.elements.every((e) => e.type === GregorioType.CLEF);
  }

  get hasEpisema(): boolean {
    return this.elements.some((e) => {
      return e.hasEpisema;
    });
  }

  split(index: number): [GregorioSegment, GregorioSegment] {
    const left = new GregorioSegment(
      this.gabcNotations,
      this.nabcNotations
    );
    left.elements = this.elements.slice(0, index);

    const right = new GregorioSegment(
      this.gabcNotations,
    );
    right.elements = this.elements.slice(index);

    return [left, right];
  }
}
